import { ChangeDetectionStrategy, Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripIdeasComponent } from '../trips/trip-ideas.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-journeys-landing-section',
  templateUrl: './journeys-landing-section.component.html',
  styleUrls: ['./journeys-landing-section.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, TripIdeasComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JourneysLandingSectionComponent { @Output() planTrip = new EventEmitter<any>(); }
